export enum DiscardTypes{
    DISCARD_AND_CONTINUE = 'DISCARD_AND_CONTINUE',
    BACK_TO_EDITING = 'BACK_TO_EDITING'
}
